import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base : '/',
  routes: [
    // 首页
    {
      path: '/nav_list',
      name: 'nav_list',
      component: require('@/pages/index/nav_list').default,
    },
    {
      path: '/points',
      name: 'points',
      component: require('@/pages/index/points').default,
    },
    {
      path: '/ser',
      name: 'ser',
      component: require('@/pages/index/ser').default,
    },
    {
      path: '/seat',
      name: 'seat',
      component: require('@/pages/index/seat').default,
    },
    // {
    //   path: '/seat_search',
    //   name: 'seat_search',
    //   component: require('@/pages/index/seat_search').default,
    // },
    {
      path: '/',
      name: 'home',
      component: require('@/pages/index/index').default,
    },
    {
      path: '/jump/to',
      name: 'jump-to',
      component: require('@/pages/jump/to').default,
    },
    {
      path: '/noteinfo',
      name: 'noteinfo',
      component: require('@/pages/note/info').default,
    },
    {
      path: '/page',
      name: 'page',
      component: require('@/pages/note/page').default,
    },
    {
      path: '/scenic',
      name: 'scenic',
      component: require('@/pages/note/index').default,
    },
    {
      path: '/shop',
      name: 'shop',
      component: require('@/pages/shop/index').default,
    },
    {
      path: '/shop/info',
      name: 'shop_info',
      component: require('@/pages/shop/info').default,
    },
    {
      path: '/article',
      name: 'article',
      component: require('@/pages/note/actlist').default,
    },
    // 票 列表
    {
      path: '/search',
      name: 'search',
      component: require('@/pages/index/search_v4').default,
    },
    // 订票信息 步骤1
    {
      path: '/personal_info',
      name: 'personal_info',
      component: require('@/pages/index/personal_info').default,
    },
    {
      path: '/personal_info2',
      name: 'personal_info2',
      component: require('@/pages/index/personal_info2').default,
    },
    // 订票信息 步骤2
    {
      path: '/confirm_info',
      name: 'confirm_info',
      component: require('@/pages/index/confirm_info').default,
    },
    // 侧栏组件
    {
      path: '/sidebar',
      name: 'sidebar',
      component: require('@/pages/index/sidebar').default,
    },
    // 面包屑组件
    {
      path: '/breadcrumb',
      name: 'breadcrumb',
      component: require('@/pages/index/breadcrumb').default,
    },

    // 预约管理
    // {
    //   path: '/booking_management',
    //   name: 'booking_management',
    //   component: require('@/pages/index/booking_management').default,
    // },

    // 个人中心
    {
      path: '/personal',
      name: 'personal',
      component: require('@/pages/index/personal').default,
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: require('@/pages/user/coupon').default,
    },
    // 巴士票
    {
      path: '/bus_list',
      name: 'bus_list',
      component: require('@/pages/index/bus_list').default,
    },
    // 巴士票/电子票
    {
      path: '/electronic_ticket',
      name: 'electronic_ticket',
      component: require('@/pages/index/electronic_ticket').default,
    },
    {
      path: '/login',
      name: 'login',
      component: require('@/pages/index/login').default,
    },
    {
      path: '/rkb',
      name: 'rkb',
      component: require('@/pages/index/rkb').default,
    },
    {
      path: '/reg',
      name: 'reg',
      component: require('@/pages/index/reg').default,
    },
    {
      path: '/edit_login',
      name: 'edit_login',
      component: require('@/pages/index/edit_login').default,
    },
    {
      path: '/buy_alert',
      name: 'buy_alert',
      component: require('@/pages/index/buy_alert').default,
    },
    {
      path: '/hot/index',
      name: 'htix',
      component: require('@/pages/hot/index').default,
    },
    {
      path: '/hot/pre_order',
      name: 'htix',
      component: require('@/pages/hot/pre_order').default,
    },
    {
      path: '/hot/pay',
      name: 'htix',
      component: require('@/pages/hot/pay').default,
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js